import { render, staticRenderFns } from "./Areaselect.vue?vue&type=template&id=1d2e266c&scoped=true"
import script from "./Areaselect.vue?vue&type=script&lang=js"
export * from "./Areaselect.vue?vue&type=script&lang=js"
import style0 from "./Areaselect.vue?vue&type=style&index=0&id=1d2e266c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2e266c",
  null
  
)

export default component.exports